import { TAB_CHANGE } from "./actionTypes";


export const tabActions = (id) => async (dispatch) => {
    dispatch({ type: TAB_CHANGE, payload: id });
  };